import { render, staticRenderFns } from "./Aboutd.vue?vue&type=template&id=16935d5b&"
import script from "./Aboutd.vue?vue&type=script&lang=js&"
export * from "./Aboutd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports